// beware store argument is coming from entities module
// see @/core/store/plugins
import { catchQueryErrors } from '@/core/shared/helpers/ErrorHelper';
const fireInteropGameChange = async ({ dispatch, rootGetters, rootState }) => {
  const { themeParkGameId, loadings } = rootState.launcher;
  const { currentStation } = rootGetters;
  const payload = rootGetters.allGames.filter(({ _tutorial }) => !_tutorial);
  try {
    // this is a HACK to give the theme park mode game id to background service by placing it at the beginning of the game list
    if (currentStation.themeParkModeEnabled) {
      if (loadings.themeParkGameId) return;
      if (!themeParkGameId) {
        await dispatch('getThemeParkGameId');
      }
      const themeParkGameIndex = payload.findIndex(
        ({ id }) => id === rootState.launcher.themeParkGameId,
      );
      const themeParkGame = payload[themeParkGameIndex];
      payload.splice(themeParkGameIndex, 1);
      payload.unshift(themeParkGame);
    }
  } catch (e) {
    catchQueryErrors();
  }
  dispatch('interop/gamesChanged', payload, { root: true });
};
export const gameUpdated = async store => {
  fireInteropGameChange(store);
};
export const stationUpdated = async ({ dispatch, rootGetters }) => {
  const currentStation = rootGetters.currentStation;
  if (!currentStation) return;
  dispatch('interop/stationChanged', currentStation, { root: true });
};
